"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldDisplay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var Tree_1 = require("./Tree");
var FieldDisplay = /** @class */ (function (_super) {
    __extends(FieldDisplay, _super);
    function FieldDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    FieldDisplay.prototype.render = function () {
        if (this.props.value) {
            return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { className: this.props.customStyle, label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "muli-bold-16", children: [this.props.label, ":"] }), " ", this.props.value] }) }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    return FieldDisplay;
}(React.Component));
exports.FieldDisplay = FieldDisplay;
//# sourceMappingURL=FieldDisplay.js.map